import React from 'react'
import withQueryParams from 'components/withQueryParams'
import { LayoutWithVertical as Layout } from 'stylist'
import { Route } from 'react-router-dom'
import RouteSignUpIndex from './sign-up/index'
import AppLogoLink from 'components/AppLogoLink'
import styled from 'react-emotion'

const StyledFooter = styled(Layout.Footer)`
  height: 70px;
`

const RouteSignUp = ({ match: { path }, query }) => (
  <Layout>
    <Layout.Header />
    <Layout.Main>
      <AppLogoLink clientId={query.get('client_id')} />
      <Route path={path} exact component={RouteSignUpIndex} />
    </Layout.Main>
    <StyledFooter />
  </Layout>
)

export default withQueryParams(RouteSignUp)



// WEBPACK FOOTER //
// ./src/routes/sign-up.js